<div class="flex flex-col gap-6">
  <div class="w-full">
    <zaeper-card>
      <p-button (onClick)="openCreateLauncherModal()" [rounded]="true">Launcher erstellen</p-button>
    </zaeper-card>
  </div>
  <div class="grid w-full cols-auto-fill-[350px] gap-6">
    @for (launcher of launchers$(); track launcher) {
      <app-application-overview-item (onClick)="openLauncherDetailPage(launcher.id)" [application]="launcher" styleClass="cursor-pointer">
        <ng-template #actions>
          <p-button (onClick)="deleteLauncher($event, launcher)" icon="pi pi-trash" [rounded]="true" severity="secondary" />
        </ng-template>
      </app-application-overview-item>
    }
  </div>
</div>
